import { goRequest as request } from '../utils/httpClientTs';

export interface WorkflowListChapter {
  id: string;
  name: string;
  status_id: string;
  status_name: string;
  contact_made: boolean;
}

export interface WorkflowListItem {
  id: string;
  first_name: string;
  last_name: string;
  name: string;
  email: string;
  status_id: string;
  status_name: string;
  created_at: string;
  chapters: WorkflowListChapter[];
}

export interface WorkflowListResponse {
  data: WorkflowListItem[];
  pagination: {
    page: number;
    per_page: number;
    total_count: number;
    total_pages: number;
    has_next: boolean;
    has_prev: boolean;
  };
}

export interface WorkflowNote {
  id: string;
  note: string;
  created_at: string;
  created_by_name: string;
}

export interface WorkflowChapter {
  id: string;
  local_chapter_id: string;
  chapter_name: string;
  abbreviation: string;
  status_id: string;
  status_name: string;
  removed_on?: string | null;
  removed_by_name?: string | null;
  contact_attempt_one?: string | null;
  contact_one_successful?: boolean | null;
  contact_attempt_two?: string | null;
  contact_two_successful?: boolean | null;
  contact_attempt_three?: string | null;
  contact_three_successful?: boolean | null;
  notes: WorkflowNote[];
}

export interface WorkflowDetail {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  home_phone?: string | null;
  cell_phone?: string | null;
  address_1?: string | null;
  address_2?: string | null;
  city?: string | null;
  state_name?: string | null;
  country_name?: string | null;
  postal_code?: string | null;
  description: string;
  status_id: string;
  status_name: string;
  created_at: string;
  created_by_name?: string;
  closed_on?: string | null;
  user_id?: string | null;
  can_edit: boolean;
  can_add_chapter: boolean;
  can_initiate: boolean;
  chapters: WorkflowChapter[];
}

export const getWorkflowIntroductions = async (params: {
  page: number;
  per_page: number;
  search?: string;
  status_id?: string;
}): Promise<WorkflowListResponse> => {
  return request({
    url: '/introductions/workflow',
    method: 'GET',
    params,
  });
};

export const getWorkflowIntroduction = async (
  id: string
): Promise<WorkflowDetail> => {
  return request({
    url: `/introductions/workflow/${id}`,
    method: 'GET',
  });
};

export const updateWorkflowChapter = async (params: {
  id: string;
  chapterId: string;
  contact_attempt?: number;
  contact_on?: string;
  successful?: boolean;
  status?: 'accepted' | 'removed';
  note?: string;
}): Promise<WorkflowDetail> => {
  const { id, chapterId, ...data } = params;
  return request({
    url: `/introductions/workflow/${id}/chapters/${chapterId}`,
    method: 'PUT',
    data,
  });
};

export const addWorkflowChapter = async (params: {
  id: string;
  local_chapter_id: string;
}): Promise<WorkflowDetail> => {
  return request({
    url: `/introductions/workflow/${params.id}/chapters`,
    method: 'POST',
    data: { local_chapter_id: params.local_chapter_id },
  });
};

export const closeWorkflowIntroduction = async (
  id: string
): Promise<WorkflowDetail> => {
  return request({
    url: `/introductions/workflow/${id}/close`,
    method: 'POST',
  });
};

export const initiateWorkflowIntroduction = async (params: {
  id: string;
  initiation_date: string;
}): Promise<WorkflowDetail> => {
  return request({
    url: `/introductions/workflow/${params.id}/initiate`,
    method: 'POST',
    data: { initiation_date: params.initiation_date },
  });
};
